module.exports = __webpack_public_path__ + "img/orders.c16edb2c.svg";